import {
    AboutUsFeature,
    BusinessCustomerFeature,
    HomeFeature,
    ImprintPageFeature,
    PrivacyFeature,
    ServicesFeature,
    ShopPageFeature,
} from '@hyundai/ng-common-lib';
import type { Identifiers } from '@hyundai/shared-lib/edit';
import { EditFeature } from '../+state';

export const DIALOG_DATAS = {
    'home.homeTeaser': {
        refreshAction: HomeFeature.actions.loadHome(),
        defaultSelector: EditFeature.state.selectHomeTeasers,
    },
    'home.theme': {
        refreshAction: HomeFeature.actions.loadHome(),
        defaultSelector: EditFeature.state.selectHomeTheme,
    },
    'about-us.headline': {
        refreshAction: AboutUsFeature.actions.loadAboutUsContent(),
        defaultSelector: EditFeature.state.selectAboutUsHeadlineHeadline,
    },
    'about-us.heroCopy': {
        refreshAction: AboutUsFeature.actions.loadAboutUsContent(),
        defaultSelector: EditFeature.state.selectAboutUsHeadlineCopy,
    },
    'about-us.heroImage': {
        refreshAction: AboutUsFeature.actions.loadAboutUsContent(),
        defaultSelector: EditFeature.state.selectAboutUsHeroImage,
    },
    'imprint.copy': {
        refreshAction: ImprintPageFeature.actions.loadDealerImprint(),
        defaultSelector: EditFeature.state.selectImprintCopy,
    },
    'about-us.aboutUsTeaser': {
        refreshAction: AboutUsFeature.actions.loadAboutUsTeaser(),
        defaultSelector: EditFeature.state.selectAboutUsTeasers,
    },
    'about-us.employees': {
        refreshAction: AboutUsFeature.actions.loadEmployees(),
        defaultSelector: EditFeature.state.selectEmployees,
    },
    'about-us.jobOfferBtnLink': {
        refreshAction: AboutUsFeature.actions.loadJobOfferContent(),
        defaultSelector: EditFeature.state.selectAboutUsJobOfferBtnLink,
    },
    'about-us.jobOfferHeroImage': {
        refreshAction: AboutUsFeature.actions.loadJobOfferContent(),
        defaultSelector: EditFeature.state.selectAboutUsJobOfferHeroImage,
    },
    'about-us.jobOfferBenefits': {
        refreshAction: AboutUsFeature.actions.loadJobOfferContent(),
        defaultSelector: EditFeature.state.selectAboutUsJobOfferBenefits,
    },
    'businessCustomer.bullet': {
        refreshAction: BusinessCustomerFeature.actions.loadPageBusinessCustomer(),
        defaultSelector: EditFeature.state.selectBusinessCustomerBulletIds,
    },
    'services.serviceTextHeadline': {
        refreshAction: ServicesFeature.actions.loadServicesHero(),
        defaultSelector: EditFeature.state.selectServiceTextHeadline,
    },
    'services.serviceText': {
        refreshAction: ServicesFeature.actions.loadServicesHero(),
        defaultSelector: EditFeature.state.selectServiceText,
    },
    'services.serviceBullet': {
        refreshAction: ServicesFeature.actions.loadServicesHero(),
        defaultSelector: EditFeature.state.selectServiceBulletIds,
    },
    'services.serviceHighlights': {
        refreshAction: ServicesFeature.actions.loadGeneralServices(),
        defaultSelector: EditFeature.state.selectServiceHighlights,
    },
    'shop.subText': {
        refreshAction: ShopPageFeature.actions.loadDealerShop(),
        defaultSelector: EditFeature.state.selectShopSubText,
    },
    'privacy.dataProtection': {
        refreshAction: PrivacyFeature.actions.loadDealerPrivacy(),
        defaultSelector: EditFeature.state.selectPrivacyDataProtection,
    },
    'dealer-campaign.image': {
        refreshAction: null,
        defaultSelector: null,
    },
    'dealer-campaign.textImage': {
        refreshAction: null,
        defaultSelector: null,
    },
    'dealer-campaign.teaserImage': {
        refreshAction: null,
        defaultSelector: null,
    },
    'dealer-campaign.leasingOfferImage': {
        refreshAction: null,
        defaultSelector: null,
    },
    'dealer-campaign.cashPriceOfferImage': {
        refreshAction: null,
        defaultSelector: null,
    },
    'dealer-campaign.financeOfferImage': {
        refreshAction: null,
        defaultSelector: null,
    },
    'home.imageTextContent': {
        refreshAction: HomeFeature.actions.loadHome(),
        defaultSelector: EditFeature.state.selectHomeImageTextContent,
    },
} as const;

export function getDialogData<T extends Identifiers>(identifier: T): (typeof DIALOG_DATAS)[T] {
    return DIALOG_DATAS[identifier];
}
export function getDialogDefaultSelector<T extends Identifiers>(
    identifier: T,
): (typeof DIALOG_DATAS)[T]['defaultSelector'] {
    return getDialogData(identifier).defaultSelector;
}
export type DialogDefaultSelectorFunk = typeof getDialogDefaultSelector;

export function getContentRefreshAction(identifier: Identifiers) {
    return getDialogData(identifier).refreshAction;
}
